import { BottomAction } from '@euler/app/components/BottomAction';
import { LinkButton } from '@euler/app/components/LinkButton';
import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { useOrderSearchNavigation } from '@euler/app/flows/search/screens';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useToggleAutomaticKeyboard } from '@euler/lib/keyboard';
import { useCallback, useEffect } from 'react';
import { Platform, ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { OrderCreateTimeRangeField } from './fields/created-at';
import { CustomerNameField } from './fields/customer-name';
import { CustomerPhoneField } from './fields/customer-phone';
import { OrderFinishTimeRangeField } from './fields/finished-at';
import { KeywordField } from './fields/keyword';
import { LicensePlateNumberField } from './fields/license-plate-number';
import { MileageRangeField } from './fields/mileage';
import { OrderNumberField } from './fields/order-number';
import { OrderStatusField } from './fields/order-status';
import { ServiceAgentField } from './fields/service-agent';
import { OrderTagsField } from './fields/tags';
import { VehicleBrandField } from './fields/vehicle-brand-name';
import { FuelTypeField } from './fields/vehicle-fuel-type';
import { VehicleModelField } from './fields/vehicle-model';
import { VINField } from './fields/vin';

export const AdvancedSearchPage = wrapNavigatorScreen(
  () => {
    const { rpx } = useResponsiveContext();
    const { bottom } = useSafeAreaInsets();

    const navigation = useOrderSearchNavigation();
    const form = useOrderSearchForm();

    const onSearch = useCallback(() => {
      navigation.navigate('_results', {});
    }, [navigation]);

    useToggleAutomaticKeyboard(true);

    const onReset = useCallback(() => {
      form.resetAll();
    }, [form]);

    useEffect(() => {
      navigation.setOptions({
        headerRight: () => (
          <LinkButton
            text="重置"
            onPress={onReset}
            style={{
              marginRight: 15,
            }}
          />
        ),
      });
      return () => {
        navigation.setOptions({ headerRight: undefined });
      };
    }, [navigation, onReset]);

    return (
      <>
        <ScrollView
          scrollEventThrottle={1}
          showsVerticalScrollIndicator={Platform.OS === 'web'}
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={{
            paddingHorizontal: rpx(15),
            paddingTop: rpx(24),
            paddingBottom: rpx(64) + bottom,
          }}
          css={`
            flex: 1;
          `}
        >
          <LicensePlateNumberField />
          <VINField />
          <ServiceAgentField />
          <OrderStatusField />
          <OrderTagsField />
          <OrderCreateTimeRangeField />
          <OrderFinishTimeRangeField />
          <MileageRangeField />
          <VehicleBrandField />
          <VehicleModelField />
          <FuelTypeField />
          <CustomerNameField />
          <CustomerPhoneField />
          <OrderNumberField />
          <KeywordField />
        </ScrollView>
        <BottomAction>
          <BottomAction.Button
            variant="primary"
            text="搜索 →"
            style={{ minWidth: rpx(200) }}
            onPress={onSearch}
          />
        </BottomAction>
      </>
    );
  },
  {
    title: '搜索订单',
  },
);
